import React from 'react';
import './LegalPolicies.css';
import useScrollToTop from './useScrollToTop';

const CookiePolicy = () => {
  useScrollToTop();
  return (
    <div className="policy-page">
      <h1>Cookie Policy</h1>
      <p>
        This Cookie Policy explains how Housekaar Construction Company uses cookies and similar tracking technologies on our website.
      </p>

      <section>
        <h2>Our Current Cookie Usage</h2>
        <p>
          At this time, Housekaar Construction Company primarily uses cookies that are **essential for the basic functionality of our website**. These cookies are necessary to enable you to navigate our site and use its core features.
        </p>
        <ul>
          <li><strong>Essential Cookies:</strong> These cookies are required for the website to function correctly. They may include session cookies that allow you to browse different pages without losing your place.</li>
        </ul>
      </section>

      <section>
        <h2>We Do Not Currently Collect Non-Essential Data Through Cookies</h2>
        <p>
          Currently, Housekaar Construction Company **does not** use cookies for analytics, marketing, or tracking user activity beyond what is strictly necessary for the website to operate. This means we are not presently collecting data about your website usage for purposes such as understanding traffic patterns or delivering targeted advertisements.
        </p>
      </section>

      <section>
        <h2>How You Can Manage Cookies</h2>
        <p>
          Even though we currently focus on essential cookies, you still have control over cookies through your browser settings. Most web browsers allow you to manage your cookie preferences, including blocking or deleting cookies. Please refer to your browser's help documentation for instructions on how to do this. Keep in mind that disabling essential cookies may impact the functionality of our website.
        </p>
      </section>

      <section>
        <h2>Third-Party Cookies</h2>
        <p>
          We strive to minimize the use of third-party cookies. If our website integrates with third-party services that may set cookies (for example, embedded maps or social media sharing buttons - though we are not heavily utilizing these at present), we will update this policy accordingly. Please review the privacy and cookie policies of these third-party providers for information on their cookie practices.
        </p>
      </section>

      <section>
        <h2>Future Updates to Our Cookie Policy</h2>
        <p>
          As our website evolves and we potentially introduce new features or services, our use of cookies may change. We will update this Cookie Policy to reflect any such changes. Please check this page periodically for the latest information.
        </p>
      </section>
    </div>
  );
};

export default CookiePolicy;